import React, { Component } from 'react';
import { Segment, Button, Icon, Form, Header, Modal } from 'semantic-ui-react';
class MessageBox extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {

        // eslint-disable-next-line
        {/* This is how implement
            <MessageBox {...this.props} box={9} open={this.state.open} close={() => { this.setState({ open: false }) }} /> 
        */}
        if (this.props.box === 1) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="cog"></Icon>Unsubmitted Accounts</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>There are no unsubmitted accounts. Would you like to enter a new account(s)?</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>No</Button>
                                <Button.Or />
                                <Button positive>Yes</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 2) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="pause"></Icon>Requested Holds</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>There are no requested holds. Would you like to place a hold?</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>No</Button>
                                <Button.Or />
                                <Button positive>Yes</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 3) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="bell"></Icon>Client Alerts</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>There are no current client alerts. Thank you for checking!</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        }
        else if (this.props.box === 4) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="exclamation triangle"></Icon>ALERT</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>This search will contain all the corporate child facilities.</p>
                            <p>Do you wish to proceed?</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>No</Button>
                                <Button.Or />
                                <Button positive>Yes</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        }
        else if (this.props.box === 5) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="exclamation triangle"></Icon>ALERT</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>You are about to submit ALL table charges, including those entered by other users.</p>
                            <p>Do you wish to proceed?</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>No</Button>
                                <Button.Or />
                                <Button positive onClick={this.props.yesHandle}>Yes</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 6) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="star"></Icon>SUCCESS!</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>Thank you for your account submissions.</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        }
        else if (this.props.box === 7) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="star"></Icon>SUCCESS!</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>Thank you. Your request has been submitted to our agency for review.</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={(this.props.exit ? this.props.exit : this.props.close)}>{this.props.t("close")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        }

        else if (this.props.box === 8) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="star"></Icon>Updated</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>Thank you. Your update has been submitted.</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        }
        else if (this.props.box === 9) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment inverted className="red center">
                            <Header as={"h4"}><Icon name="search"></Icon>Search Parameter Needed</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>You must provide at least one search parmeter.</p>
                            <p>Please enter into or select from at least one input field.</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        }
        else if (this.props.box === 10) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="red center" inverted >
                            <Header as={"h4"}><Icon name="exclamation triangle"></Icon>ALERT</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>You have unsaved changes.</p>
                            <p>Would you like to save them before leaving this page?</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>No</Button>
                                <Button.Or />
                                <Button positive>Yes</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 11) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="red center" inverted >
                            <Header as={"h4"}><Icon name="search"></Icon>Missing Information for Required Field(s)</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>Please exit this alert and enter into or select from the following required field(s):</p>
                            {
                                (() => {
                                    return this.props.required.map((item, index) => {
                                        return (
                                            <p key={index}>{item}</p>
                                        )
                                    })
                                }
                                )()
                            }
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 12) {
            return (
                <Modal size={this.props.size} open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="red center" inverted >
                            <Header as={"h4"}><Icon name="exclamation triangle"></Icon>{this.props.contentTitle}</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>{this.props.content}</p>
                        </Segment>
                        <Segment secondary clearing>
                            {
                                (() => {
                                    if (this.props.yesHandle) {
                                        return (<Button.Group className="right floated small buttons">
                                            <Button onClick={this.props.close}>No</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.props.yesHandle}>Yes</Button>
                                        </Button.Group>)
                                    } else {
                                        return (
                                            <Button.Group className="right floated small buttons">
                                                <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                                            </Button.Group>
                                        )
                                    }
                                })()
                            }

                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 13) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="red center" inverted >
                            <Header as={"h4"}><Icon name="search"></Icon>Confirm Email(s) Deletion</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>You are about to permanently delete this email(s).</p>
                            <p>Are you sure you wish to proceed?</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>No</Button>
                                <Button.Or />
                                <Button positive>Yes</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 14) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="center" inverted >
                            <Header as={"h4"}><Icon name="exclamation triangle"></Icon>Save or Send Draft?</Header>
                        </Segment>
                        <Segment className="center aligned">
                            <p>Would you like to SAVE the Draft or SEND the Email?</p>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button>Save Draft</Button>
                                <Button.Or />
                                <Button positive>Send Email</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 15) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="red center" inverted >
                            <Header as={"h4"}><Icon name="exclamation triangle"></Icon>Don't Use</Header>
                        </Segment>
                        <Segment>
                            <Form>
                                <Form.Field>
                                    <div className="required field">
                                        <label>Don't Use</label>
                                        <select className="fluid dropdown">
                                            <option value="">Select</option>
                                            <option value="1">Reason 1</option>
                                            <option value="2">Reason 2, etc.</option>
                                        </select>
                                    </div>
                                </Form.Field>
                                <Form.Field>
                                    <label>Any Comments?</label>
                                    <textarea rows="2"></textarea>
                                </Form.Field>
                            </Form>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>Exit</Button>
                                <Button.Or />
                                <Button positive>{this.props.t("submit")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        }
        else if (this.props.box === 16) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    {this.props.children}
                </Modal>
            );
        }
        else if (this.props.box === 17) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="comment"></Icon>Add a Comment</Header>
                        </Segment>
                        <Segment>
                            <Form>
                                <Form.Field>
                                    <label>Add a Comment</label>
                                    <textarea rows="2"></textarea>
                                </Form.Field>
                            </Form>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>Cancel</Button>
                                <Button.Or />
                                <Button positive>{this.props.t("submit")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } else if (this.props.box === 18) {
            return (
                <Modal size="small" open={this.props.open} onClose={this.props.close} style={{ background: "none" }} closeIcon>
                    <Segment.Group>
                        <Segment className="black center" inverted >
                            <Header as={"h4"}><Icon name="comment"></Icon>#</Header>
                        </Segment>
                        <Segment>
                            <Form>
                                <Form.Field className="required">

                                </Form.Field>
                                <Form.Field>
                                </Form.Field>
                            </Form>
                        </Segment>
                        <Segment secondary clearing>
                            <Button.Group className="right floated small buttons">
                                <Button onClick={this.props.close}>Cancel</Button>
                                <Button.Or />
                                <Button positive>{this.props.t("submit")}</Button>
                            </Button.Group>
                        </Segment>
                    </Segment.Group>
                </Modal>
            );
        } return (
            <div></div>
        );
    }
}
export default MessageBox;


// WEBPACK FOOTER //
// ./src/app/ui/MessageBox.js